import Optiscroll from 'optiscroll'
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      tvChannels: state => state.guide.tvChannels
    }),
    ...mapGetters([
      'favoriteChannelsTv'
    ]),
    channelListExits: function () {
      return this.favoriteChannelsTv.length > 0
    }
  },
  methods: {
    initOptiscroll: function () {
      this.scrollAreaDOM = this.$el.querySelector('.channel-list-ul')
      this.optiscrollInstance = new Optiscroll(this.scrollAreaDOM, {
        wrapContent: false
      })
    }
  },
  beforeDestroy: function () {
    if (this.channelListExits) {
      this.optiscrollInstance.destroy()
      // console.log('ChannelList destroy optiscroll...')
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/mixins/ChannelListMixin.js